// src/pages/agenda/MiniCalendario.js — o mês no alto da coluna da esquerda.
//
// Hoje em verde; a semana (ou o dia) que está na grade fica sombreada; um
// ponto embaixo do número marca dia com compromisso. Clicar abre o dia.
import { Box } from '@mui/material';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { DMINI, MESES, cap, dnum, gradeDoMes, inicioSemana, add, mon, yr } from './datas';
import { FONT_NUM, botaoBase, cartao } from './estilo';

const seta = {
  ...botaoBase, width: 26, height: 26, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 0,
  border: '1px solid var(--ch-bdr)', borderRadius: '6px', bgcolor: 'transparent', color: 'var(--ch-text2)',
  '&:hover': { color: 'var(--ch-text)', bgcolor: 'var(--ch-inset)' },
};

export default function MiniCalendario({ cursor, view, hoje, comEvento, onDia, onMes }) {
  const { dias } = gradeDoMes(cursor);
  const semIni = inicioSemana(cursor);
  const semFim = add(semIni, 6);
  const mesAtual = cursor.slice(0, 7);
  return (
    <Box sx={{ ...cartao, flex: 'none', p: '12px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '6px' }}>
        <Box component="h2" sx={{ m: 0, fontSize: '0.85rem', fontWeight: 700, color: 'var(--ch-text)' }}>
          {cap(MESES[mon(cursor)])} {yr(cursor)}
        </Box>
        <Box sx={{ display: 'flex', gap: '4px' }}>
          <Box component="button" type="button" aria-label="Mês anterior" onClick={() => onMes(-1)} sx={seta}><FiChevronLeft size={14} /></Box>
          <Box component="button" type="button" aria-label="Próximo mês" onClick={() => onMes(1)} sx={seta}><FiChevronRight size={14} /></Box>
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', mb: '4px' }}>
        {DMINI.map((d, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={i} component="span" sx={{ textAlign: 'center', fontSize: '0.62rem', fontWeight: 700, color: 'var(--ch-text3)', py: '2px' }}>{d}</Box>
        ))}
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', rowGap: '2px' }}>
        {dias.map((s) => {
          const ehHoje = s === hoje;
          const outro = s.slice(0, 7) !== mesAtual;
          const naSemana = view === 'semana' && s >= semIni && s <= semFim;
          const doDia = view === 'dia' && s === cursor;
          const tem = comEvento.has(s);
          return (
            <Box
              key={s} component="button" type="button" onClick={() => onDia(s)}
              aria-label={`${dnum(s)} de ${MESES[mon(s)]}${tem ? ', com compromisso' : ''}`}
              aria-current={ehHoje ? 'date' : undefined}
              sx={{
                ...botaoBase, height: 28, p: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '2px',
                border: `1px solid ${doDia && !ehHoje ? 'var(--ch-bdr2)' : 'transparent'}`, borderRadius: '7px',
                bgcolor: ehHoje ? 'var(--ch-green)' : (naSemana || doDia) ? 'var(--ch-inset)' : 'transparent',
                fontFamily: FONT_NUM, fontSize: '0.75rem', fontWeight: ehHoje || doDia ? 700 : 500,
                color: ehHoje ? 'var(--ch-on-green)' : outro ? 'var(--ch-text3)' : 'var(--ch-text)',
                '&:hover': { borderColor: 'var(--ch-bdr2)' },
              }}
            >
              <Box component="span" sx={{ lineHeight: 1 }}>{dnum(s)}</Box>
              <Box component="span" sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: tem && !outro && !ehHoje ? 'var(--ch-text3)' : 'transparent' }} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
